<div class="preloader-item" [ngClass]="{'post-loaded': showPost}" [ngStyle]="{'background':preloader_color}">
</div>
<div #workdiv id="element-{{work.slug}}" class="w-100 h-100 post-container">
    <div class="post-hover-overlay" *ngIf="bannerItem" 
        [ngClass]="{'white-hover': bannerItem.title_and_subtitle_color == 'black'}"></div>
<div #quickcontent class="quickview-acitve-content" [ngClass]="{'active':iframeIsLoaded || imageIsLoaded }">
    <h5 class=" post-client heading7 f-darker">{{work.acf.subtitle}}</h5>
    <h3 class="heading3 heading3-works-m f-darker">{{work.title.rendered}}</h3>
    <div class="more-button">
        <a class="link1 link-darker" routerLink="{{slug}}" (click)="callPostFromQuickView()" >See More</a>
    </div>
</div>
<img *ngIf="bannerItem && is_safari && screenWidth > 1024 && !isTouchDevice && !isIPadPro"   class="banner-image-safari" src="{{bannerItem?.banner_item}}" alt="" [ngClass]="{'d-none':displayItemSafari}">

<div #postactive class="grid-wrapper-container post-active-wrapper" [ngClass]="{'transition-quickview':transitionactive}">
    <!-- (mouseenter)="playHoverVideo()" (mouseleave)="pauseHoverVideo()" > -->

     <div *ngIf="screenWidth > 1024"
          (click)="itemActive($event)" class="post-hover-item"  
        [ngClass]="{'b-dark-3': bannerItem?.title_and_subtitle_color == 'white',
                    'b-white': bannerItem?.title_and_subtitle_color == 'black',
        'fade-out': quickViewActive }">
     </div>

     <a (click)="itemActive($event)" class="image-wrapper" routerLink="{{slug}}" [queryParams]="{'key' : key}"
     queryParamsHandling="merge">
        <img *ngIf="bannerItem" class="banner-image fade-out" src="{{bannerItem.banner_item}}" (load)="loadedImage()" [ngClass]="{'active': showPost, 'reset-transition':resetTransition, 'hovered-in-video': workHoverInVideo, 'hovered-in-slide': workHoverInSlide }"  alt="">

        <!-- <div class="video" [ngClass]="{'square-post': postsize == 4, 'fullpage-post': postsize == 8}" #hoverVideoplayer *ngIf="this.work.acf.project_modules[0].work_page_video">
            <iframe allowtransparency="true" class="e2e-iframe-trusted-src" loading="lazy"
                [src]="videoOnHoverUrl" frameborder=0>
            </iframe>
        </div> -->

        <div class="slides" *ngIf="!this.work.acf.project_modules[0].work_page_video">
            <div class="slide" *ngFor="let item of this.work.acf.project_modules[0].banner_gallery; let i = index"  [ngClass]="{'active': activeSliderImage==i}">
                <img src="{{item.banner_item}}" alt="">
            </div>
        </div>
    </a>
    <div class="quickview-gallery-conatiner" *ngIf="galleryIsLoaded" [ngClass]="{'is-loaded':imageIsLoaded}">
        <div class="quick-view-item" *ngFor="let gallery of work.acf.project_modules[0].banner_gallery; let i = index" [ngClass]="{'fade-in': activeSlide == i}">
            <img src="{{gallery.banner_item}}"  (load)="imageLoaded()" alt="">
        </div>
        <div class="dots-wrapper quickview-dots-wrapper">
            <a (click)="activeQuivkViewSlide(j)" class="gallery-dots" 
              *ngFor="let dots of  work.acf.project_modules[0].banner_gallery;  let j = index">
                <div class="dots-inner-wrapper" 
                [ngClass]="{'dark-dots': work.acf.project_modules[0].banner_gallery[activeSlide].title_and_subtitle_color == 'black',
                            'white-dots': work.acf.project_modules[0].banner_gallery[activeSlide].title_and_subtitle_color == 'white'}"
                [ngStyle]="{'width': labelwidth +'px'}">
                    <mat-progress-bar *ngIf="activeSlide == j" mode="determinate" value="{{dotswidth}}"></mat-progress-bar>
                </div>
            </a>
        </div>            
    </div>
    <div class="quick-view-container"  *ngIf="work.acf.project_modules[0].banner_video" [ngClass]="{'is-loaded':iframeIsLoaded}">
        <div #videoplayer class="quick-view-video-container">
            <div class="quick-view-controll-wrapper"  (mousemove)="onMouseMove($event)">
                <div class="click-action" *ngIf="ispaused" (click)="player.pause(); isplaying = true; ispaused = false;">

                </div>
                <div class="click-action"  *ngIf="isplaying" (click)="player.play(); isplaying = false; ispaused = true;">

                </div>
                <div class="timer-counter" *ngIf="player && bannerItem" [ngClass]="{'show-duration':hiddeButton}">
                    <div class="float-left d-flex" 
                    [ngClass]="{'f-white': bannerItem.title_and_subtitle_color == 'white',
                    ' f-darker': bannerItem.title_and_subtitle_color == 'black' }"
                    *ngIf="player.minuteprogress">{{player.minuteprogress}} : {{player.secondprogress}} </div> 
                    <div class=" float-left d-flex space-side-3" *ngIf="player.minuteprogress"
                    [ngClass]="{'f-white': bannerItem.title_and_subtitle_color == 'white',
                    ' f-darker': bannerItem.title_and_subtitle_color == 'black' }">/</div>
                    <div class="f-white d-flex" *ngIf="player.totalminuteduration"
                    [ngClass]="{'f-white': bannerItem.title_and_subtitle_color == 'white',
                    ' f-darker': bannerItem.title_and_subtitle_color == 'black' }"
                    >{{player.totalminuteduration}} : {{player.totalsecondduration}} </div>
               </div>
                <div class="seek-bar" *ngIf="player">
                    <div class="slider" (click)="seekOutside($event)">
                      <div class="slider-item"  [ngStyle]="{'width': player.seekbarproggress +'%'}"></div>
                    </div>
                  </div>
            </div>
            <iframe 
                (load)="iframeLoaded()"
                class="e2e-iframe-trusted-src" 
                loading="lazy"
                *ngIf="videourl" 
                [src]="videourl"
                frameborder=0   
                allowfullscreen="true" 
                mozallowfullscreen="true" 
                webkitallowfullscreen="true" 
                allow="autoplay; fullscreen">
            </iframe>
        </div>
    </div>
     <div *ngIf="bannerItem" class="post-content-wrapper">
        <a (click)="itemActive($event)"  
            routerLink="{{slug}}" 
            queryParamsHandling="merge" 
            class="grid-wrapper-content"
            [ngClass]="{'fade-out':quickViewActive}"
            >
            <h5 class="post-client heading7 {{fadeclass}}"
            [ngClass]="{'animate': showPost,
                        'post-f-white': bannerItem.title_and_subtitle_color == 'white',
                        'post-f-darker': bannerItem.title_and_subtitle_color == 'black'}">{{work.acf.subtitle}}</h5>
            <h3 class="post-title heading3 {{fadeclass}} font-bold heading3-works-m" 
            [ngClass]="{'animate': showPost,
                        'post-f-white': bannerItem.title_and_subtitle_color == 'white',
                        'post-f-darker': bannerItem.title_and_subtitle_color == 'black' }">{{work.title.rendered}}</h3> 
        </a> 
    </div>
    <div class="button-wrapper  {{fadeclass}}" 
         *ngIf="bannerItem" 
         [ngClass]="{'animate': showPost,'fade-out':quickViewActive }">
            <a *ngIf="screenWidth > 1024 && type !== 'related'" class="link1" 
                [ngClass]="{'post-link-white': bannerItem.title_and_subtitle_color == 'white',
            'post-link-darker': bannerItem.title_and_subtitle_color == 'black'}"
            (click)="showQuickView($event)">Quick View</a>
    </div>

</div>
</div>


<div class="fade-overlay-quickview">
</div>
<div class="d-none d-lg-block fade-overlay-menu fade-overlay-work" [ngClass]="{'active': activateMenuOverlay}">
</div>
<div #playeroverlay class="player-overlay" (click)="removeQuickView()">

</div>

<div class="view-port-detect"
inViewport
[inViewportOptions]="{ threshold: [0] }"
(inViewportAction)="onIntersection($event)">
</div>